module.exports = __webpack_public_path__ + "static/media/phone-solid.302b81d2.png";